import { topicItems } from '@/mocks/animeData';

const hotColorMap: Record<string, string> = {
  '火爆': 'bg-primary-100 text-primary-700 border-primary-300',
  '火热': 'bg-accent-100 text-accent-700 border-accent-300',
  '热门': 'bg-secondary-100 text-secondary-700 border-secondary-200',
  '推荐': 'bg-background-100 text-foreground-600 border-background-300',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            当下最火的动漫话题都在这里，快来加入讨论
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-[800px] mx-auto">
          {topicItems.map((topic) => {
            const colorStyle = hotColorMap[topic.hot] || hotColorMap['推荐'];
            return (
              <span
                key={topic.name}
                className={`inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full border ${colorStyle} text-sm font-medium hover:scale-105 transition-transform cursor-pointer`}
              >
                {topic.name}
                <span className="text-xs opacity-70">#{topic.hot}</span>
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}